interface Props {
  open: boolean;
  onClose: () => void;
  title?: string;
}

export default function PlayModal({ open, onClose, title }: Props) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm animate-fade-in" onClick={onClose}></div>
      <div className="relative w-full max-w-md bg-background-100 border border-background-300/60 rounded-lg p-6 md:p-8 animate-modal-in">
        <div className="w-14 h-14 rounded-full bg-primary-500/15 flex items-center justify-center mb-4">
          <i className="ri-movie-2-line text-3xl text-primary-500"></i>
        </div>
        <h3 className="text-lg font-bold text-foreground-950 mb-2">演示说明</h3>
        <p className="text-sm text-foreground-700 leading-relaxed">
          当前站点为前端演示项目，暂不包含真实影片播放数据与接口。
          {title ? `《${title}》` : ''}的在线播放功能仅为界面展示效果，实际播放能力将在接入正版片源后开放。
        </p>
        <button
          type="button"
          onClick={onClose}
          className="mt-6 w-full py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
        >
          我知道了
        </button>
      </div>
    </div>
  );
}